import React, { createContext, useContext } from "react";
import useContextPapers from "../hooks/useContextPapers";

const PaperContext = createContext(null);

export function PaperProvider({ children }) {
  const paperState = useContextPapers();
  return <PaperContext.Provider value={paperState}>{children}</PaperContext.Provider>;
}

export function usePaperContext() {
  const context = useContext(PaperContext);
  if (!context) {
    throw new Error("usePaperContext must be used within a PaperProvider");
  }
  return context;
}

export function useOptionalPaperContext() {
  return useContext(PaperContext);
}

export default PaperContext;
